<div class="apg-panel qq-summary" [appScrollIntoView]="!loading">
  <div class="title" *ngIf="!error">
    {{headerLine1}} <span>{{subheader}}</span>
  </div>

  <div class="apg-loading">
    <ion-spinner *ngIf="loading"></ion-spinner>
  </div>

  <div class="qq-summary__block" *ngIf="!loading">
    <div class="sub-title" *ngIf="!error">
      <p>Thank you for completing the Dividend Life application!</p>
      <!-- <p *ngIf="quote.result.premium === magnumPremium.basePremium">We have assessed the information provided and can
        offer cover.</p>
      <p *ngIf="quote.result.premium !== magnumPremium.basePremium">The premium has been adjusted following assessing
        the information you have provided.</p> -->
    </div>

    <div *ngIf="!loading && !result?.error && magnumPremium">
      <app-questionnaire-summary [title]="getTitle(answersObject['PolicyType_1'])">
        <app-summary-row label="Life Cover of">
          {{answersObject["ProtectionLevel_1"] | pounds}}
        </app-summary-row>
        <app-summary-row label="Cover Length">
          {{answersObject["PolicyTerm_1"]}} years
        </app-summary-row>
        <app-summary-row label="Cover Type">
          {{answersObject["CoverBasis_1"] === 'LEVEL' ? 'Level term Family cover': 'Decreasing term Mortgage cover'}}
        </app-summary-row>
      </app-questionnaire-summary>

      <app-questionnaire-summary *ngIf="answersObject['PolicyType_2']"
                                 [title]="getTitle(answersObject['PolicyType_2'])">
        <app-summary-row label="Life with Multi-Claim Critical Illness Cover of">
          {{answersObject["ProtectionLevel_2"] | pounds}}
        </app-summary-row>
        <app-summary-row label="Cover Length">
          {{answersObject["PolicyTerm_2"]}} years
        </app-summary-row>
        <app-summary-row label="Cover Type">
          {{answersObject["CoverBasis_2"] === 'LEVEL' ? 'Level term Family cover': 'Decreasing term Mortgage cover'}}
        </app-summary-row>
      </app-questionnaire-summary>

      <app-site-content class="premium-change"
                        *ngIf="!error && quote.result.premium !== magnumPremium.basePremium && canProceed"
                        key="FullQuote.PremiumChangeNotification"></app-site-content>
      
      <div class="qq-summary__result" *ngIf="magnumPremium"> 
        <label class="qq-summary__block__preheader">
          <span>Your old monthly premium: {{magnumPremium.originalPremium | appcurrency:'GBP':'1.2-2'}}</span>
        </label>
        <label class="qq-summary__block__header">
          <span *ngIf="canProceed">Your updated premium</span>
          <span *ngIf="!canProceed">Your estimated premium based on the information you have provided</span>
        </label>
        <label class="qq-summary__block__amount">
        {{magnumPremium.basePremium | pounds}}<small>{{magnumPremium.basePremium | appcents}}</small>
          <span class="pm">/month</span>
        </label>

        <label class="qq-summary__block__valid">
          Quote valid until: {{quote.result.validUntil | date:'dd/MM/yyyy'}}
        </label>
      </div>
    </div>

    <ng-container *ngIf="!confirmRequote">
      <app-site-content *ngIf="canProceed && !error" key="FullQuote.MagnumResultsContinue" class="continue-message"
                        [class.has-ci]="answersObject['PolicyType_2']?.endsWith('-CI')" [data]="magnumPremium">
      </app-site-content>

      <app-site-content class="d-block" *ngIf="errorKey" [key]="errorKey" [showTitle]="false"></app-site-content>

      <div *ngIf="customError">
        <div class="content-title"></div>
        <div>{{customError}}</div>
      </div>

      <div class="summary__buttons">
        <ion-button (click)="back.emit()">
          <ion-icon name="chevron-back-outline"></ion-icon>
          Back
        </ion-button>

        <ion-button (click)="continue.emit()" *ngIf="!errorKey && !customError">
          Continue
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>

      <div>
        <a href="javascript:void(0)" *ngIf="canRequote" (click)="confirmRequote = true">
          To re-quote please click here
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="confirmRequote">
      <app-site-content class="d-block invalid-feedback" key="FullQuote.ConfirmRequote"></app-site-content>

      <div class="summary__buttons" [appScrollIntoView]="true">
        <ion-button (click)="newQuote.emit()">Yes</ion-button>
        <ion-button (click)="confirmRequote = false">No</ion-button>
      </div>
    </ng-container>
  </div>
</div>